export const BaseUrl = "https://elearning.growforsure.com/api/" ;
export const BaseUrl2 = "https://elearning.growforsure.com/" ;